module.exports = __webpack_public_path__ + "img/hotel-28.fa17016c.jpeg";